/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
const ConstJobStates = {
  rev: {
    0: 'Initializing',
    1: 'Running',
    2: 'Ended',
    3: 'Interrupted',
    4: 'Aborted'
  },

  Initialized: 0,
  Running: 1,
  Ended: 2,
  Interrupted: 3,
  Aborted: 4
};

export default ConstJobStates;
